export default {
  "title": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Vue 3 i18n"])},
  "description": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Una app Vue i18n next usando el componente i18n para traducir"])}
}